module.exports = __webpack_public_path__ + "img/banner.9bf6d6e7.jpg";